import * as React from 'react'
import { Button } from '../../atoms/button/button'
import { LayoutModalMessage } from '../layout-modal-message/layout-modal-message'
import { siteUrl } from "../../../shared/utils/siteUrl"
import AgeCharacterImg from '../../../assets/images/age-character.svg'
import WarningIcon from '../../../assets/images/warning-icon.svg'
import './modal-invalid-age.scss'

export const ModalInvalidAge = ({ onClose }) => {
  React.useEffect(() => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interacciones - Lo sentimos',
      category: 'cole challenge',
      action: 'alerta',
      label: 'rango de edad',
    })
  },[])
  return (
    <LayoutModalMessage
      className="f-modal-invalid-age"
      headerImage={{ url: AgeCharacterImg, description: 'character image' }}
      icon={{ url: WarningIcon, description: 'warning icon' }}
      onClose={onClose}
      title="¡LO SENTIMOS!"
      description={
        <>
        
          <p>
            Para participar en esta actividad debes tener entre{' '}
        {
          process.env.LOCALE === "es-EC" || process.env.LOCALE === "es-PE" ?
            <b>9 y 17 años.</b>
          : <b>9 y 19 años.</b>
        }
          </p>

          <p>
            Dirígete a <a href="/">NosotrasOnline</a> para que disfrutes del
            resto del contenido que tenemos para ti.
          </p>
        </>
      }
      buttons={
          <Button
            color="blue"
            type="link"
            href={siteUrl}
            text="ENTIENDO"
            className="f-invalid-age__body__buttons__button"
            action={()=>{
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interacciones - Rango de edad',
                category: 'cole challenge',
                action: 'click',
                label: 'entendido',
              })
            }}
          />
      }
    />
  )
}
